document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('[data-wm-configurator]').forEach((configurator) => {
    const variantsNode = configurator.querySelector('[data-wm-config-variants]');
    const variantInput = configurator.querySelector('[data-wm-config-variant-id]');
    const priceNode = configurator.querySelector('[data-wm-config-price]');
    const submitButton = configurator.querySelector('[data-wm-config-submit]');
    const sizeGuideToggle = configurator.querySelector('[data-size-guide-toggle]');
    const sizeGuide = configurator.querySelector('[data-size-guide]');
    const renderers = (configurator.closest('.spoils-product') || document).querySelectorAll('[data-wm-frame-render]');
    const currency = configurator.dataset.currency || 'USD';
    const productTitle = configurator.dataset.productTitle || 'Artwork';

    if (!variantsNode || !variantInput || !priceNode || !submitButton) return;

    let variants = [];
    try {
      variants = JSON.parse(variantsNode.textContent);
    } catch (error) {
      return;
    }

    const money = new Intl.NumberFormat(document.documentElement.lang || 'en-US', {
      style: 'currency',
      currency,
      maximumFractionDigits: 0
    });

    const frameClass = (frame) => `wm-frame--${frame.toLowerCase().replaceAll(' ', '-')}`;
    const getChecked = (name) => configurator.querySelector(`input[name="${name}"]:checked`)?.value;

    const updateFrame = (frame, variant) => {
      const nextClass = frameClass(frame);
      renderers.forEach((renderer) => {
        renderer.classList.remove('wm-frame--no-frame', 'wm-frame--oak', 'wm-frame--white', 'wm-frame--black', 'wm-frame--dark-oak');
        renderer.classList.add(nextClass);
        renderer.dataset.selectedFrame = frame;
        const photo = renderer.querySelector('[data-wm-variant-preview]');
        const renderedFrame = renderer.querySelector('.wm-render-frame');
        if (photo && renderedFrame) {
          const preview = variant?.preview;
          photo.hidden = !preview;
          renderedFrame.hidden = !!preview;
          if (preview) {
            photo.src = preview;
            photo.alt = `${productTitle} — ${frame}`;
          }
        }
        renderer.setAttribute('aria-label', `${productTitle}, ${frame.toLowerCase()} option`);
      });
    };

    const updateVariant = () => {
      const size = getChecked('wm-size');
      const frame = getChecked('wm-frame');
      const variant = variants.find((item) => item.options[0] === size && item.options[1] === frame);
      if (!variant) return;

      variantInput.value = variant.id;
      priceNode.textContent = money.format(Number(variant.price) / 100);
      submitButton.disabled = !variant.available;
      submitButton.classList.toggle('sold-out', !variant.available);
      submitButton.textContent = variant.available ? 'Add to bag' : 'Sold out';
      updateFrame(frame, variant);

      const nextUrl = new URL(window.location.href);
      nextUrl.searchParams.set('variant', variant.id);
      window.history.replaceState({}, '', nextUrl);
    };

    configurator.querySelectorAll('input[name="wm-size"], input[name="wm-frame"]').forEach((input) => {
      input.addEventListener('change', updateVariant);
    });

    if (sizeGuideToggle && sizeGuide) {
      sizeGuideToggle.addEventListener('click', () => {
        const willOpen = sizeGuide.hidden;
        sizeGuide.hidden = !willOpen;
        sizeGuideToggle.setAttribute('aria-expanded', String(willOpen));
      });
    }

    updateFrame(getChecked('wm-frame') || 'No Frame', variants.find((item) => String(item.id) === variantInput.value));
  });
});
